require('./server-info-modal.component.scss');

export const ServerInfoModalController = function(
  $scope,
  $modalInstance,
  $timeout,
  $http,
) {
  this.$http = $http;
  $scope.loadData = () => {
    $scope.options = [];
    this.$http.get('/common-info-about-server/', {})
      .then(res => {
        $scope.options = res.data;
      });
  };
  $scope.cancel = () => $modalInstance.dismiss('cancel');
  $scope.loadData();
};



// WEBPACK FOOTER //
// ./src/core/server-info/server-info-modal.component.js